var map = {
	"./Group.png": 21106,
	"./LoginImg.png": 35639,
	"./PlusIcon.png": 1656,
	"./Send2.png": 19231,
	"./VetInstantLogo.png": 94942,
	"./VetInstantNew.png": 27721,
	"./VetInstantWhite.png": 93500,
	"./addDiscount.png": 46159,
	"./adyar.png": 82790,
	"./allergyIcon.png": 23092,
	"./applologo.png": 15520,
	"./attach.png": 33180,
	"./bodyMap.png": 53589,
	"./bodyMapMain.png": 5274,
	"./bookvector.png": 26005,
	"./bottom_section.png": 52306,
	"./branch.png": 47411,
	"./brief.png": 98395,
	"./calOrg.png": 20189,
	"./calReg.png": 84889,
	"./calen.png": 97838,
	"./calendar.png": 58681,
	"./calendarOutline.png": 67915,
	"./calender.png": 48949,
	"./calendernew.png": 82615,
	"./chat.png": 72609,
	"./clkYel.png": 95569,
	"./clock.png": 43473,
	"./closeBlack.png": 48646,
	"./closeWhite.png": 45448,
	"./collectAdvance.png": 57951,
	"./comingsoon.png": 36875,
	"./contact.png": 43983,
	"./cross.png": 54691,
	"./crossRed.png": 77750,
	"./dangerInfo.png": 43086,
	"./del.png": 36524,
	"./delGry.png": 52094,
	"./delete-new.png": 86903,
	"./delete.png": 78474,
	"./delivery.png": 88619,
	"./diagnostics.png": 60863,
	"./dialmax.png": 90399,
	"./discount.png": 87794,
	"./edit-new.png": 35170,
	"./edit.png": 69159,
	"./edit2.png": 6325,
	"./editNew.png": 12573,
	"./editPen.png": 97726,
	"./editWitTxt.png": 97631,
	"./editYellow.png": 48431,
	"./emoji.png": 54689,
	"./emprofile.png": 65730,
	"./eye.png": 19764,
	"./files.png": 39230,
	"./forms.png": 42830,
	"./gallery.png": 92905,
	"./grid.png": 67339,
	"./guindy.png": 61811,
	"./heart.png": 38831,
	"./home.png": 79246,
	"./hospitallogo.png": 82760,
	"./imageupload.png": 2991,
	"./imgAttach.png": 67045,
	"./info.png": 51247,
	"./infoBle.png": 22156,
	"./key.png": 50318,
	"./list.png": 47507,
	"./login.png": 84140,
	"./logo.png": 63222,
	"./maxiView.png": 42019,
	"./med.png": 4105,
	"./mic.png": 11002,
	"./micBlack.png": 83973,
	"./minView.png": 81644,
	"./minus.png": 37747,
	"./monday.png": 32203,
	"./nashik.png": 24257,
	"./notIcon.png": 90167,
	"./notification.png": 59670,
	"./pay.png": 54969,
	"./petFeet.png": 15328,
	"./plus.png": 91755,
	"./plusGry.png": 7535,
	"./plusnew.png": 99233,
	"./prescription.png": 45811,
	"./print.png": 20574,
	"./profile.png": 95652,
	"./profilepic.png": 55986,
	"./qrcodedown.png": 65581,
	"./redminus.png": 67596,
	"./refresh.png": 95162,
	"./save.png": 12756,
	"./sendIcon.png": 55378,
	"./settings.png": 43500,
	"./soapNotes.png": 41251,
	"./steath.png": 40480,
	"./tasks.png": 72021,
	"./tick.png": 35580,
	"./treatPlan.png": 82290,
	"./vet.png": 80786,
	"./vetinstantIcon.png": 20944,
	"./view.png": 89264,
	"./vitals.png": 75898,
	"./weight-new.png": 57814,
	"./weight.png": 17579
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70259;